import React from 'react';
import PropTypes from 'prop-types';
import Head from 'next/head';
import { useInView } from '@blaze-react/utils/lib/customHooks';
import { ResponsiveImage } from '@blaze-cms/image-cdn-react';
import { IN_VIEW_CONFIG } from './constants';

const LongformGalleryImage = ({
  id,
  url,
  caption,
  altText,
  priority,
  className,
  numberOfImages,
  handleImageOnClick,
  ...props
}) => {
  const [isIntersecting, outerRef] = useInView(IN_VIEW_CONFIG);
  const shouldRender = priority || isIntersecting;
  const HeadComponent = priority ? Head : null;
  const sizeKey = `carousel:longform:${numberOfImages}`;

  return (
    <div ref={outerRef} className={`${className}`}>
      <div
        role="button"
        className="longform-gallery__images__image__container"
        data-testid="longform-gallery__images__image__container"
        onClick={() => handleImageOnClick(id)}>
        {shouldRender && (
          <ResponsiveImage
            sizeKey={sizeKey}
            role="button"
            src={url}
            alt={altText}
            priority={priority}
            HeadComponent={HeadComponent}
            {...props}
          />
        )}
      </div>
      {!!caption && (
        <div
          className="longform-gallery__images__image__details"
          data-testid="longform-gallery__images__image__details">
          <div className="longform-gallery__images__image__details__caption">{caption}</div>
        </div>
      )}
    </div>
  );
};

LongformGalleryImage.propTypes = {
  id: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  caption: PropTypes.string.isRequired,
  numberOfImages: PropTypes.number.isRequired,
  altText: PropTypes.string.isRequired,
  priority: PropTypes.bool.isRequired,
  className: PropTypes.string.isRequired,
  handleImageOnClick: PropTypes.func.isRequired
};

export default LongformGalleryImage;
